import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { AdminLayout } from "@/components/AdminLayout";

// Public Pages
import HomePage from "@/pages/HomePage";
import QuotePage from "@/pages/QuotePage";
import PricingPage from "@/pages/PricingPage";
import FAQPage from "@/pages/FAQPage";
import InsurancePage from "@/pages/InsurancePage";
import ContactPage from "@/pages/ContactPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import DisclaimerPage from "@/pages/DisclaimerPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import QuoteResultPage from "@/pages/QuoteResultPage";
import ResumePaymentPage from "@/pages/ResumePaymentPage";

// Admin Pages
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import DashboardPage from "@/pages/admin/DashboardPage";
import LoadsPage from "@/pages/admin/LoadsPage";
import LoadDetailPage from "@/pages/admin/LoadDetailPage";
import CarriersPage from "@/pages/admin/CarriersPage";
import CarrierProfilePage from "@/pages/admin/CarrierProfilePage";
import CarrierSearchPage from "@/pages/admin/CarrierSearchPage";
import ShippersPage from "@/pages/admin/ShippersPage";
import AuditLogsPage from "@/pages/admin/AuditLogsPage";
import ConnectorHealthPage from "@/pages/admin/ConnectorHealthPage";
import KPIPage from "@/pages/admin/KPIPage";
import NotificationsPage from "@/pages/admin/NotificationsPage";
import SettingsPage from "@/pages/admin/SettingsPage";
import EventsPage from "@/pages/admin/EventsPage";
import SubscriptionsPage from "@/pages/admin/SubscriptionsPage";
import PaymentsReportPage from "@/pages/admin/reports/PaymentsReportPage";
import LoadPerformancePage from "@/pages/admin/reports/LoadPerformancePage";
import CarrierScorecardPage from "@/pages/admin/reports/CarrierScorecardPage";
import FraudDashboardPage from "@/pages/admin/FraudDashboardPage";
import FraudCasesPage from "@/pages/admin/FraudCasesPage";
import FraudCaseDetailPage from "@/pages/admin/FraudCaseDetailPage";
import IPBlocklistPage from "@/pages/admin/IPBlocklistPage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/quote" element={<QuotePage />} />
            <Route path="/quote/:loadId" element={<QuoteResultPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/insurance" element={<InsurancePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/disclaimer" element={<DisclaimerPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/resume/:token" element={<ResumePaymentPage />} />

            {/* Admin Routes — AdminLayout persists across navigation */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route element={<AdminLayout />}>
              <Route path="/admin" element={<DashboardPage />} />
              <Route path="/admin/loads" element={<LoadsPage />} />
              <Route path="/admin/loads/:loadId" element={<LoadDetailPage />} />
              <Route path="/admin/carriers" element={<CarriersPage />} />
              <Route path="/admin/carriers/search" element={<CarrierSearchPage />} />
              <Route path="/admin/carriers/:carrierId" element={<CarrierProfilePage />} />
              <Route path="/admin/shippers" element={<ShippersPage />} />
              <Route path="/admin/audit-logs" element={<AuditLogsPage />} />
              <Route path="/admin/connector-health" element={<ConnectorHealthPage />} />
              <Route path="/admin/kpi" element={<KPIPage />} />
              <Route path="/admin/notifications" element={<NotificationsPage />} />
              <Route path="/admin/settings" element={<SettingsPage />} />
              <Route path="/admin/events" element={<EventsPage />} />
              <Route path="/admin/subscriptions" element={<SubscriptionsPage />} />
              <Route path="/admin/reports/payments" element={<PaymentsReportPage />} />
              <Route path="/admin/reports/load-performance" element={<LoadPerformancePage />} />
              <Route path="/admin/reports/carrier-scorecard" element={<CarrierScorecardPage />} />
              <Route path="/admin/fraud" element={<FraudDashboardPage />} />
              <Route path="/admin/fraud/cases" element={<FraudCasesPage />} />
              <Route path="/admin/fraud/cases/:caseId" element={<FraudCaseDetailPage />} />
              <Route path="/admin/fraud/blocklist" element={<IPBlocklistPage />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
